import React, { Component } from "react";
import axios from "axios";
import { Spin } from "antd";
import Bridge from "../../utils/Bridge";

export default class KeyStatistics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      client_code: "",
      records_object: "",
      loading: false,
    };
  }
  componentDidMount() {
    this.get_key_statistics();
  }
  get_key_statistics = () => {
    let client_code = this.props.client_code;
    this.setState({ loading: true });
    let params = `/${client_code}?stat=keystat`;
    Bridge.personal_data_viewer
      .get_key_statistics(params)
      .then((res) => {
        this.setState({ records_object: res.data, loading: false });
      })
      .catch((err) => {
        this.setState({ loading: false });
      });
  };
  render() {
    const customStyle = {
      fontSize: "19px",
      textAlign: "center",
      padding: "16px 0 0 0",
    };
    return (
      <div className="row">
        <div className="col-md-12">
          {this.state.records_object && (
            <div className="keystatistics_table">
              <Spin spinning={this.state.loading}>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th scope="col" style={{ width: 374 }}>
                        Data
                      </th>
                      <th scope="col" className="text-center">
                        Last Session
                      </th>
                      {/* <th scope="col" className="text-center">
                        Last 30 Days Average
                      </th> */}
                      <th scope="col" className="text-center">
                        All Time Average
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">Project: Everything ALS Speech Study</th>
                      <td className="text-center"></td>
                      {/* <td className="text-center"></td> */}
                      <td className="text-center"></td>
                    </tr>
                    <tr>
                      <th scope="row">Words Per Minute</th>
                      <td className="text-center">
                        {this.state.records_object.LAST_SESSION_WPM
                          ? Math.round(
                              this.state.records_object.LAST_SESSION_WPM
                            )
                          : 0}
                      </td>
                      {/* <td className="text-center">
                        {this.state.records_object.AVG_WPM_LAST_MONTH
                          ? Math.round(
                              this.state.records_object.AVG_WPM_LAST_MONTH
                            )
                          : 0}
                      </td> */}
                      <td className="text-center">
                        {" "}
                        {this.state.records_object.AVG_WPM_ALL_TIME
                          ? Math.round(
                              this.state.records_object.AVG_WPM_ALL_TIME
                            )
                          : 0}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Puh Tuh Kuh Syllables</th>
                      <td className="text-center">
                        {this.state.records_object.LAST_SESSION_DDK_AMR_DURATION
                          ? Math.round(
                              this.state.records_object
                                .LAST_SESSION_DDK_AMR_DURATION
                            )
                          : 0}
                      </td>
                      {/* <td className="text-center">
                        {this.state.records_object
                          .AVG_DDK_AMR_DURATION_LAST_MONTH
                          ? Math.round(
                              this.state.records_object
                                .AVG_DDK_AMR_DURATION_LAST_MONTH
                            )
                          : 0}
                      </td> */}
                      <td className="text-center">
                        {this.state.records_object.AVG_DDK_AMR_DURATION_ALL_TIME
                          ? Math.round(
                              this.state.records_object
                                .AVG_DDK_AMR_DURATION_ALL_TIME
                            )
                          : 0}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Loudness (dB)</th>
                      <td className="text-center">
                        {this.state.records_object.LAST_SESSION_AH_DURATION
                          ? this.state.records_object.LAST_SESSION_AH_DURATION
                          : 0}
                      </td>
                      {/* <td className="text-center">
                        {this.state.records_object.AVG_AH_DURATION_LAST_MONTH
                          ? this.state.records_object.AVG_AH_DURATION_LAST_MONTH
                          : 0}
                      </td> */}
                      <td className="text-center">
                        {this.state.records_object.AVG_AH_DURATION_ALL_TIME
                          ? Math.round(
                              this.state.records_object.AVG_AH_DURATION_ALL_TIME
                            )
                          : 0}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Spin>
            </div>
          )}
          {!this.state.records_object && (
            <p className="text-center" style={customStyle}>
              Not available.
            </p>
          )}
        </div>
      </div>
    );
  }
}
